import mergeImages from 'merge-images';

const mergeColLabels = async (label1, label2) => {
    const images = [
        {src: label1, x: 0, y: 0},
        {src: label2, x: 230, y: 0}
    ];

    const options = {
        width: 460,
        height: 170
    };

    const b64 = await mergeImages(images, options);

    return b64;
};

export default mergeColLabels;
